import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "x-white",
  "use": "x-white-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol viewBox=\"0 0 12 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"x-white\">\n<path d=\"M3.38565 0.363636H0.970881L4.60156 6.18182L0.925426 12H3.35724L5.94815 7.76705H6.03906L8.62997 12H11.0732L7.43111 6.18182L11.0163 0.363636H8.61293L6.03906 4.625H5.94815L3.38565 0.363636Z\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol